import type { Props } from './OnrampPurchaseCta'
import OnrampPurchaseCta from './OnrampPurchaseCta'
import { ShoppingProvider } from './ShoppingContext'

function OnrampPurchaseCTAContainer(props: Props) {
  return (
    <ShoppingProvider>
      <OnrampPurchaseCta {...props} />
    </ShoppingProvider>
  )
}

export default OnrampPurchaseCTAContainer
